import { render, staticRenderFns } from "./Forty_percent.vue?vue&type=template&id=995af712&scoped=true"
import script from "./Forty_percent.vue?vue&type=script&lang=js"
export * from "./Forty_percent.vue?vue&type=script&lang=js"
import style0 from "./Forty_percent.vue?vue&type=style&index=0&id=995af712&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995af712",
  null
  
)

export default component.exports